'use client';

export const Warning = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M16 22.5C15.6 22.5 15.3 22.6 15.1 22.9C14.9 23.1 14.7 23.4 14.7 23.8C14.7 24.2 14.8 24.5 15.1 24.7C15.3 24.9 15.6 25.1 16 25.1C16.4 25.1 16.7 25 16.9 24.7C17.1 24.5 17.3 24.2 17.3 23.8C17.3 23.4 17.2 23.1 16.9 22.9C16.6 22.6 16.4 22.5 16 22.5ZM29.8 26.7L17 4.6C16.9 4.4 16.7 4.3 16.6 4.2C16.4 4 16.2 4 16 4C15.8 4 15.6 4 15.4 4.1C15.2 4.2 15.1 4.3 15 4.5L2.2 26.7C2 26.9 2 27.1 2 27.3C2 27.5 2.1 27.7 2.2 27.8C2.3 28 2.4 28.1 2.6 28.2C2.8 28.3 3 28.4 3.2 28.4H28.9C29.1 28.4 29.3 28.3 29.5 28.2C29.7 28.1 29.8 28 29.9 27.8C30 27.6 30.1 27.5 30.1 27.3C30 27.1 30 26.9 29.8 26.7ZM4.4 26.6L16 6.5L27.6 26.6H4.4ZM15.3 12.7C15.1 12.9 15 13.1 15 13.4V19.4C15 19.7 15.1 19.9 15.3 20.1C15.5 20.3 15.7 20.4 16 20.4C16.3 20.4 16.5 20.3 16.7 20.1C16.9 19.9 17 19.7 17 19.4V13.4C17 13.1 16.9 12.9 16.7 12.7C16.5 12.5 16.3 12.4 16 12.4C15.7 12.5 15.5 12.5 15.3 12.7Z"
				fill="currentColor"
			/>
		</svg>
	);
};
